import { zh } from './common'
import fba from './FBA/zh-CN'
import fund from './funding/zh-CN'
import saledFeedback from './feedback/zh-CN'
import recharge from './recharge/zh-CN'
import cnumber from './cNumber/zh-CN'
import cs from './ws/zh-CN'

const t = {
  common: zh,
  fba,
  fund,
  saledFeedback,
  recharge,
  cnumber,
  cs,
}

t.loading = '加载中...'

t.brand = {}
t.brand.lg = '中日快递-客户端'
t.brand.mini = '中日'

t.add = '新增'
t.delete = '删除'
t.deleteBatch = '删除'
t.update = '修改'
t.query = '搜索'
t.export = '导出'
t.handle = '操作'
t.confirm = '确定'
t.cancel = '取消'
t.logout = '退出'
t.reset = '重置'
t.detail = '详情'
t.editor = '编辑'
t.success = '操作成功'
t.submit = '提交'
t.import = '导入'
t.baoc = '保存'
t.submitOrder = '提交订单'

t.search = {
  search1: '运单号',
  search2: '反馈编号',
  search3: '至',
  search4: '类型',
  search5: '交易开始日期', //
  search6: '交易结束日期', //
  search7: '交易编号',
  search8: '交易类型',
}

t.status = {
  status1: '待处理', //
  status2: '处理中', //
  status3: '处理完', //
  status4: '已取消', //
  status5: '未收到货', //
  status6: '商品缺少', //
  status7: '商品损毁', //
  status8: '商品瑕疵', //
  status9: '费用问题', //
  status10: '其他', //
  status11: '已审核',
  status12: '审核未通过',
}

t.prompt = {}
t.prompt.title = '提示'
t.prompt.info = '确定进行[{handle}]操作?'
t.prompt.success = '操作成功'
t.prompt.failed = '操作失败'
t.prompt.deleteBatch = '请选择删除项'

t.validate = {}
t.validate.required = '必填项不能为空'
t.validate.format = '{attr}格式错误'
t.validate.fileFormat = '文件格式错误'

t.upload = {}
t.upload.text = '将文件拖到此处，或<em>点击上传</em>'
t.upload.tip = '只支持{format}格式文件！'
t.upload.button = '点击上传'
t.upload.typeErr = '文件类型不匹配，无法上传'

t.datePicker = {}
t.datePicker.range = '至'
t.datePicker.start = '开始日期'
t.datePicker.end = '结束日期'

t.fullscreen = {}
t.fullscreen.prompt = '您的浏览器不支持此操作'

t.updatePassword = {}
t.updatePassword.title = '修改密码'
t.updatePassword.username = '账号'
t.updatePassword.password = '原密码'
t.updatePassword.newPassword = '新密码'
t.updatePassword.comfirmPassword = '确认密码'
t.updatePassword.validate = {}
t.updatePassword.validate.comfirmPassword = '确认密码与新密码输入不一致'

t.contentTabs = {}
t.contentTabs.closeCurrent = '关闭当前标签页'
t.contentTabs.closeOther = '关闭其它标签页'
t.contentTabs.closeAll = '关闭全部标签页'

/* 页面 */
t.notFound = {}
t.notFound.desc = '抱歉！您访问的页面<em>失联</em>啦...'
t.notFound.back = '上一页'
t.notFound.home = 'TOP'

t.login = {}
t.login.title = '登录'
t.login.username = '用户名：'
t.login.password = '密码'
t.login.captcha = '验证码'
t.login.demo = '在线演示'
t.login.copyright = '人人开源'

t.home = {}
t.home.sysInfo = {}
t.home.sysInfo.name = '系统名称'
t.home.sysInfo.nameVal = 'renren-security【企业版】'
t.home.sysInfo.version = '版本信息'
t.home.sysInfo.osName = '操作系统'
t.home.sysInfo.osVersion = '系统版本'
t.home.sysInfo.osArch = '系统架构'
t.home.sysInfo.processors = 'CPU核数'
t.home.sysInfo.totalPhysical = '系统内存'
t.home.sysInfo.freePhysical = '剩余内存'
t.home.sysInfo.memoryRate = '内存使用'
t.home.sysInfo.userLanguage = '系统语言'
t.home.sysInfo.jvmName = 'JVM信息'
t.home.sysInfo.javaVersion = 'JVM版本'
t.home.sysInfo.javaHome = 'JAVA_HOME'
t.home.sysInfo.userDir = '工作目录'
t.home.sysInfo.javaTotalMemory = 'JVM占用内存'
t.home.sysInfo.javaFreeMemory = 'JVM空闲内存'
t.home.sysInfo.javaMaxMemory = 'JVM最大内存'
t.home.sysInfo.userName = '当前用户'
t.home.sysInfo.systemCpuLoad = 'CPU负载'
t.home.sysInfo.userTimezone = '系统时区'

/* 模块 */
t.model = {}
t.model.name = '名称'
t.model.key = '标识'
t.model.version = '版本'
t.model.createTime = '创建时间'
t.model.lastUpdateTime = '更新时间'
t.model.design = '在线设计'
t.model.deploy = '部署'
t.model.description = '描述'

t.process = {}
t.process.name = '名称'
t.process.key = '标识'
t.process.deployFile = '部署流程文件'
t.process.id = '流程ID'
t.process.deploymentId = '部署ID'
t.process.version = '版本'
t.process.resourceName = 'XML'
t.process.diagramResourceName = '图片'
t.process.deploymentTime = '部署时间'
t.process.active = '激活'
t.process.suspend = '挂起'
t.process.convertToModel = '转换为模型'

t.running = {}
t.running.id = '实例ID'
t.running.definitionKey = '定义Key'
t.running.processDefinitionId = '定义ID'
t.running.processDefinitionName = '定义名称'
t.running.activityId = '当前环节'
t.running.suspended = '是否挂起'
t.running.suspended0 = '否'
t.running.suspended1 = '是'

t.news = {}
t.news.title = '标题'
t.news.pubDate = '发布时间'
t.news.createDate = '创建时间'
t.news.content = '内容'

t.schedule = {}
t.schedule.beanName = 'bean名称'
t.schedule.beanNameTips = 'spring bean名称, 如: testTask'
t.schedule.pauseBatch = '暂停'
t.schedule.resumeBatch = '恢复'
t.schedule.runBatch = '执行'
t.schedule.log = '日志列表'
t.schedule.params = '参数'
t.schedule.cronExpression = 'cron表达式'
t.schedule.cronExpressionTips = '如: 0 0 12 * * ?'
t.schedule.remark = '备注'
t.schedule.status = '状态'
t.schedule.status0 = '暂停'
t.schedule.status1 = '正常'
t.schedule.statusLog0 = '失败'
t.schedule.statusLog1 = '成功'
t.schedule.pause = '暂停'
t.schedule.resume = '恢复'
t.schedule.run = '执行'
t.schedule.jobId = '任务ID'
t.schedule.times = '耗时(单位: 毫秒)'
t.schedule.createDate = '执行时间'

t.mail = {}
t.mail.name = '名称'
t.mail.config = '邮件配置'
t.mail.subject = '主题'
t.mail.createDate = '创建时间'
t.mail.send = '发送邮件'
t.mail.content = '内容'
t.mail.smtp = 'SMTP'
t.mail.port = '端口号'
t.mail.username = '邮箱账号'
t.mail.password = '邮箱密码'
t.mail.mailTo = '收件人'
t.mail.mailCc = '抄送'
t.mail.params = '模板参数'
t.mail.paramsTips = '如：{"code": "123456"}'
t.mail.templateId = '模版ID'
t.mail.status = '状态'
t.mail.status0 = '发送失败'
t.mail.status1 = '发送成功'
t.mail.mailFrom = '发送者'
t.mail.createDate = '发送时间'

t.sms = {}
t.sms.mobile = '手机号'
t.sms.status = '状态'
t.sms.status0 = '发送失败'
t.sms.status1 = '发送成功'
t.sms.config = '短信配置'
t.sms.send = '发送短信'
t.sms.platform = '平台类型'
t.sms.platform1 = '阿里云'
t.sms.platform2 = '腾讯云'
t.sms.params = '参数'
t.sms.paramsTips = '如：{"code": "123456"}'
t.sms.params1 = '参数1'
t.sms.params2 = '参数2'
t.sms.params3 = '参数3'
t.sms.params4 = '参数4'
t.sms.createDate = '发送时间'
t.sms.aliyunAccessKeyId = 'Key'
t.sms.aliyunAccessKeyIdTips = '阿里云AccessKeyId'
t.sms.aliyunAccessKeySecret = 'Secret'
t.sms.aliyunAccessKeySecretTips = '阿里云AccessKeySecret'
t.sms.aliyunSignName = '短信签名'
t.sms.aliyunTemplateCode = '短信模板'
t.sms.aliyunTemplateCodeTips = '短信模板CODE'
t.sms.qcloudAppId = 'AppId'
t.sms.qcloudAppIdTips = '腾讯云AppId'
t.sms.qcloudAppKey = 'AppKey'
t.sms.qcloudAppKeyTips = '腾讯云AppKey'
t.sms.qcloudSignName = '短信签名'
t.sms.qcloudTemplateId = '短信模板'
t.sms.qcloudTemplateIdTips = '短信模板ID'

t.oss = {}
t.oss.config = '云存储配置'
t.oss.upload = '上传文件'
t.oss.url = 'URL地址'
t.oss.createDate = '创建时间'
t.oss.type = '类型'
t.oss.type1 = '七牛'
t.oss.type2 = '阿里云'
t.oss.type3 = '腾讯云'
t.oss.type4 = 'FastDFS'
t.oss.type5 = '本地上传'
t.oss.qiniuDomain = '域名'
t.oss.qiniuDomainTips = '七牛绑定的域名'
t.oss.qiniuPrefix = '路径前缀'
t.oss.qiniuPrefixTips = '不设置默认为空'
t.oss.qiniuAccessKey = 'AccessKey'
t.oss.qiniuAccessKeyTips = '七牛AccessKey'
t.oss.qiniuSecretKey = 'SecretKey'
t.oss.qiniuSecretKeyTips = '七牛SecretKey'
t.oss.qiniuBucketName = '空间名'
t.oss.qiniuBucketNameTips = '七牛存储空间名'
t.oss.aliyunDomain = '域名'
t.oss.aliyunDomainTips = '阿里云绑定的域名，如：http://cdn.renren.io'
t.oss.aliyunPrefix = '路径前缀'
t.oss.aliyunPrefixTips = '不设置默认为空'
t.oss.aliyunEndPoint = 'EndPoint'
t.oss.aliyunEndPointTips = '阿里云EndPoint'
t.oss.aliyunAccessKeyId = 'AccessKeyId'
t.oss.aliyunAccessKeyIdTips = '阿里云AccessKeyId'
t.oss.aliyunAccessKeySecret = 'AccessKeySecret'
t.oss.aliyunAccessKeySecretTips = '阿里云AccessKeySecret'
t.oss.aliyunBucketName = 'BucketName'
t.oss.aliyunBucketNameTips = '阿里云BucketName'
t.oss.qcloudDomain = '域名'
t.oss.qcloudDomainTips = '腾讯云绑定的域名'
t.oss.qcloudPrefix = '路径前缀'
t.oss.qcloudPrefixTips = '不设置默认为空'
t.oss.qcloudAppId = 'AppId'
t.oss.qcloudAppIdTips = '腾讯云AppId'
t.oss.qcloudSecretId = 'SecretId'
t.oss.qcloudSecretIdTips = '腾讯云SecretId'
t.oss.qcloudSecretKey = 'SecretKey'
t.oss.qcloudSecretKeyTips = '腾讯云SecretKey'
t.oss.qcloudBucketName = 'BucketName'
t.oss.qcloudBucketNameTips = '腾讯云BucketName'
t.oss.qcloudRegion = '所属地区'
t.oss.qcloudRegionTips = '请选择'
t.oss.qcloudRegionBeijing1 = '北京一区（华北）'
t.oss.qcloudRegionBeijing = '北京'
t.oss.qcloudRegionShanghai = '上海（华东）'
t.oss.qcloudRegionGuangzhou = '广州（华南）'
t.oss.qcloudRegionChengdu = '成都（西南）'
t.oss.qcloudRegionChongqing = '重庆'
t.oss.qcloudRegionSingapore = '新加坡'
t.oss.qcloudRegionHongkong = '香港'
t.oss.qcloudRegionToronto = '多伦多'
t.oss.qcloudRegionFrankfurt = '法兰克福'
t.oss.localDomain = '域名'
t.oss.localDomainTips = '绑定的域名，如：http://cdn.renren.io'
t.oss.fastdfsDomain = '域名'
t.oss.fastdfsDomainTips = '绑定的域名，如：http://cdn.renren.io'
t.oss.localPrefix = '路径前缀'
t.oss.localPrefixTips = '不设置默认为空'
t.oss.localPath = '存储目录'
t.oss.localPathTips = '如：D:/upload'

t.dept = {}
t.dept.name = '名称'
t.dept.parentName = '上级部门'
t.dept.sort = '排序'
t.dept.parentNameDefault = '一级部门'

t.dict = {}
t.dict.dictName = '名称'
t.dict.dictType = '类型'
t.dict.dictValue = '值'
t.dict.sort = '排序'
t.dict.remark = '备注'
t.dict.createDate = '创建时间'

t.logError = {}
t.logError.requestUri = '请求URI'
t.logError.requestMethod = '请求方式'
t.logError.requestParams = '请求参数'
t.logError.ip = '操作IP'
t.logError.userAgent = '用户代理'
t.logError.createDate = '创建时间'
t.logError.errorInfo = '异常信息'

t.logLogin = {}
t.logLogin.creatorName = '用户名：'
t.logLogin.status = '状态'
t.logLogin.status0 = '失败'
t.logLogin.status1 = '成功'
t.logLogin.status2 = '账号已锁定'
t.logLogin.operation = '操作类型'
t.logLogin.operation0 = '登录'
t.logLogin.operation1 = '退出'
t.logLogin.ip = '操作IP'
t.logLogin.userAgent = 'User-Agent'
t.logLogin.createDate = '创建时间'

t.logOperation = {}
t.logOperation.status = '状态'
t.logOperation.status0 = '失败'
t.logOperation.status1 = '成功'
t.logOperation.creatorName = '用户名：'
t.logOperation.operation = '用户操作'
t.logOperation.requestUri = '请求URI'
t.logOperation.requestMethod = '请求方式'
t.logOperation.requestParams = '请求参数'
t.logOperation.requestTime = '请求时长'
t.logOperation.ip = '操作IP'
t.logOperation.userAgent = 'User-Agent'
t.logOperation.createDate = '创建时间'

t.menu = {}
t.menu.name = '名称'
t.menu.icon = '图标'
t.menu.type = '类型'
t.menu.type0 = '菜单'
t.menu.type1 = '按钮'
t.menu.sort = '排序'
t.menu.url = '路由'
t.menu.permissions = '授权标识'
t.menu.permissionsTips = '多个用逗号分隔，如：sys:menu:save,sys:menu:update'
t.menu.parentName = '上级菜单'
t.menu.parentNameDefault = '一级菜单'
t.menu.resource = '授权资源'
t.menu.resourceUrl = '资源URL'
t.menu.resourceMethod = '请求方式'
t.menu.resourceAddItem = '添加一项'

t.params = {}
t.params.paramCode = '编码'
t.params.paramValue = '值'
t.params.remark = '备注'

t.role = {}
t.role.name = '名称'
t.role.remark = '备注'
t.role.createDate = '创建时间'
t.role.menuList = '菜单授权'
t.role.deptList = '数据授权'

t.user = {}
t.user.username = '用户名：'
t.user.deptName = '所属部门'
t.user.email = '邮箱'
t.user.mobile = '手机号'
t.user.status = '状态'
t.user.status0 = '停用'
t.user.status1 = '正常'
t.user.createDate = '创建时间'
t.user.password = '密码'
t.user.comfirmPassword = '确认密码'
t.user.realName = '真实姓名'
t.user.gender = '性别'
t.user.gender0 = '男'
t.user.gender1 = '女'
t.user.gender2 = '保密'
t.user.roleIdList = '角色配置'
t.user.validate = {}
t.user.validate.comfirmPassword = '确认密码与密码输入不一致'

t.home = {
  list1: `依据《中华人民共和国海关法》；
  《海关总署关于启用新快件通关系统相关事宜的公告》（海关总署公告2016年第19号）等法规要求，收货人必须提供
  身份证件影印件证明用途办理个人物品类进出境快件报关手续。
  如果无法提供则需要填写承诺书。如收货人拒绝提供身份证正反面影印件或者承诺书，包裹将无法清关。海关将进行退运处理。
  由此造成的的损失将我们将不承担任何责任。请大家给与配合`,
  list2: `小包打包规则

  1.单个包裹价格在海关允许胡范围以内。

  2.总数量10个以内，申报商品数量6种内（相同条码6件内），不超1.6公斤！

  3.食品、保健品、母婴用品、化妆品以及其它杂货（相同条码6件内），奶粉2罐一个包裹（不得放其它物品）

  4.成人衣服6件、儿童服装8件、内衣10件内（不是同一包裹内）

  5.箱包单独打包。

  6.鞋子单独打包（儿童鞋2双以内）

  7.家电及不含锂电池的数码产品、配件、手表单独打包。

  8.影音光盘类（5盘内，套装限一套，若只发影音光盘，最高可发10件或3套内）

  9.时效3-7天

  10.违禁品、处方药、奢侈品、宝石、珍珠、珊瑚等珍贵首饰类（香奈儿、爱马仕、LV、GUCCL、卡地亚、迪奥、范思哲、巴宝莉、普拉达、芬迪、菲拉格慕、纪梵希、劳力士、百达翡丽、江诗丹顿、伯爵、欧米茄、积家、万国、宝玑、肖邦、沛纳海、朗格、爱彼等所有奢饰品禁止邮寄）。“明治”“固力果”字样的婴幼儿奶粉的产地为日本枥木、琦玉等核辐射区，属于禁止进境货物，2011 年日本福岛核泄漏事故发 生后，我国已发布禁令禁止产地为日本核辐射区（福岛、群马、枥木、茨城、宫城、新泻、长野、琦玉、东京、千叶等地区）的食品进入中国境内，这一禁令到目前仍然有效。 日本婴幼儿奶粉品牌，明 治，森永，雪印，和光堂，固力果，等其它生产于核辐射区的食品禁止进境，请自查。发现有来自核辐射区的食品，该包裹进行销毁处理， 不可邮寄，严禁私自夹带，造成的后果损失自行承担！

  11.单一不可分割物品（单独打包）实报价格按照实际价格交税。

  *商品数量限制可能根据海关要求随时调整，实际以本页面最新公示为准！

  **航空或货运规定的危险品；运送、进出口受包括经由国在内的进出口国、州、地方自治区的法令禁止或限制的物品；航空、运输公司的运输协议中不允许承运的其他物品；本公司认为不符合规定的其他物品。

  以上物品无法使用本公司公司的清关服务。本公司有开封检查商品内容的权利，进行检验时怀疑有违反法律法规可能性的商品时，本公司可以采取报告警察及相关执法部门，提交商品等措施。若检验商品及采 取本条规定的处理办法造成会员损失时，本公司不承担任何责任。本公司开封检查商品，一旦发现不符合本规定的商品及违禁品将立即停止服务，并可以马上废弃或以其他方法处置。清关的商品必须符合进出 口国的法律法规以及其他利益相关方的要求，对于违反了法律或者特定要求的商品，本公司可以随时停止服务并不承担任何的责任.`,
  list3: `*违禁品禁发明细

  1 禁止进境物品

  1.1 各种武器、仿真武器、弹药及爆炸物品；

  1.2 伪造的货币及伪造的有价证券；

  1.3 对中国政治、经济、文化、道德有害的印刷品、胶卷、照片、唱片、影片、录音带、录像带、激光视盘、计算机存储介质及其它物品；

  1.4 各种烈性毒药；

  1.5 鸦片、吗啡、海洛因、大麻以及其它能使人成瘾的麻醉品、精神药物；

  1.6 带有危险性病菌、害虫及其它有害生物的动物、植物及其产品；

  1.7 有碍人畜健康的、来自疫区的以及其它能传播疾病的食品、药品或其它物品；

  1.8 法律、法规及海关禁止进境的其他物品。

  2 限制进境物品

  2.1 无线电收发信机、通信保密机；

  2.2 烟、酒；宝石、珍珠、珊瑚等珍贵首饰类。

  2.3 濒危的和珍贵的动物、植物（均含标本）及其种子和繁殖材料；

  2.4 国家货币；

  2.5 海关限制进境的其他物品。

  3 禁寄物品

  3.1 各类武器、弹药。如枪支、子弹、炮弹、手榴弹、地雷、炸弹等；

  3.2 各类易爆炸性物品。如雷管、炸药、火药、鞭炮等；

  3.3 各类易燃烧性物品，包括液体、气体和固体。如汽油、煤油、桐油、酒精、生漆、柴油、气雾剂、气体打火机、瓦斯气瓶、磷、硫磺、火柴等、

  3.4 各类易腐蚀性物品。如火硫酸、盐酸、硝酸、有机溶剂、农药、双氧水、危险化学品等；

  3.5 各类放射性元素及容器。如铀、钴、镭、钚等；

  3.6 各类烈性毒药。如铊、氰化物、砒霜等；

  3.7 各类麻醉药物。如鸦片（包括罂粟壳、花、苞、叶）、吗啡、可卡因、海洛因、大麻、冰毒、麻黄素及其它制品等；

  3.8 各类生化制品和传染性物品。如炭疽、危险性病菌、医药用废弃物等；

  3.9 各种危害国家安全和社会政治稳定以及淫秽的出版物、宣传品、印刷品等；

  3.10 各种妨害公共卫生的物品。如尸骨、动物器官、肢体、未经硝制的兽皮、未经药制的兽骨等；

  3.11 国家法律、法规、行政规章明令禁止流通、寄递或进出境的物品，如国家秘密文件和资料、国家货币及伪造的货币和有价证券、仿真武器、管制刀具、珍贵文物、濒危野生动物及其制品等；

  3.12 包装不妥，可能危害人身安全、污染或者损毁其他寄递件、设备的物品等；

  3.13 各寄达国（地区）禁止寄递进口的物品等；

  3.14 其他禁止寄递的物品。

  一、动物及动物产品类

  （一）活动物（犬、猫除外【2】），包括所有的哺乳动物、鸟类、鱼类、两栖类、爬行类、昆虫类和其他无脊椎动物，动物遗传物质。

  （二）（生或熟）肉类（含脏器类）及其制品；水生动物产品。

  （三） 动物源性奶及奶制品，包括生奶、鲜奶、酸奶，动物源性的奶油、黄油、奶酪等奶类产品。

  （四）蛋及其制品，包括鲜蛋、皮蛋、咸蛋、蛋液、蛋壳、蛋黄酱等蛋源产品。

  （五）燕窝（罐头装燕窝除外）。

  （六）油脂类，皮张、毛类，蹄、骨、牙、角类及其制品。

  （七）动物源性饲料（含肉粉、骨粉、鱼粉、乳清粉、血粉等单一饲料）、动物源性中药材、动物源性肥料。

  二、植物及植物产品类

  （八）新鲜水果、蔬菜。

  （九）烟叶（不含烟丝）。

  （十）种子（苗）、苗木及其他具有繁殖能力的植物材料。

  （十一）有机栽培介质。

  三.其他类

  （十二）菌种、毒种等动植物病原体，害虫及其他有害生物，细胞、器官组织、血液及其制品等生物材料。

  （十三）动物尸体、动物标本、动物源性废弃物。

  （十四）土壤

  （十五）转基因生物材料。

  （十六）国家禁止进境的其他动植物、动植物产品和其他检疫物。`,
  list4: `由于对国内快递运输过程中无法控制的原因，我们对运输过程中快件破损所造成的损失无法理赔，请对易损物品一定做加固处理。

  如货物丢失，请提供丢失包裹订单号、国际运输单号、丢失包裹内所有商品在购物网站的订单截图（或购物小票） （截图/小票需能体现具体破损商品明细，购买价值，收货地址和快递单号等重要信息），按商品实际价值/用户申报价值两者较小金额进行赔付， 最高赔付金额为1500元（申报价值和商品数量以用户扫码录入系统为准，如有疑问请联系客服修改）。`,
  list5: `亲爱的客户，

  您好

  接关口通知，根据山东省防疫政策要求，自4月10日开始，机场进口货物集中监管仓启用，要求货物到达后在

  监管仓静置10天

  ，进行货物消毒以及抽样检测。

  此政策最大限度保证收货安全，给各位客户带来服装线及杂货普线物流时效延长敬请谅解！

  如需政策相关官方文件可联系客服发送。`,
  home1: '金牌代理',
  home2: '资金余额',
  home3: '充值',
  home4: '使用流程',
  home5: '发送包裹到日仓',
  home6: '客户提交运单',
  home7: '日仓签收/打包/称重',
  home8: '客户支付运费',
  home9: '国际运输、通关',
  home10: '中国国内配送',
  home11: '邮箱验证',
  home12: '签收包裹',
  home13: '业务统计',
  home14: '重要通知',
  home15: '待支付运单',
  home16: '运单编号',
  home17: '金额（元）',
  home18: '支付',
  home19: '全部运单',
  home20: '待支付运单',
  home21: '异常运单',
  home22: '收/发货人数',
  home23: '售后反馈',
  home24: '提供收货人身份证正反面的通知',
  home25: '打包规则明细',
  home26: '违禁品禁发清单',
  home27: '违禁品禁发清单',
  home28: '关于清关静置的通知',
}

t.wzbg = {
  wz1: '创建开始日期',
  wz2: '创建结束日期',
  wz3: '包裹编号',
  wz4: '重置',
  wz5: '状态',
  wz6: '序号',
  wz7: '物流公司',
  wz8: '日本物流单号',
  wz9: '认领时间',
  wz10: '认领',
  wz11: '创建运单',
  wz12: '包裹认领',
  wz13: '取消',
  wz14: '确定',
  wz15: '请输入日本物流单号',
  wz16: '待认领',
  wz17: '已认领',
  wz18: '取消成功',
  wz19: '全部',
}

t.menu = {
  menu1: '信息管理',
  menu2: '商品列表',
  menu3: '新增商品',
  menu4: '编辑商品',
  menu5: '商品详情',
  menu6: '发/收货人管理',
  menu7: '账号管理',
  menu8: '账号信息设置',
  menu9: '账号安全设置',
  menu10: '账号安全-更改邮箱账号',
  menu11: '账号安全-修改登录密码',
  menu12: '财务管理',
  menu13: '资金记录',
  menu14: '客户充值',
  menu15: '运单管理',
  menu16: '运单列表',
  menu17: '新增运单',
  menu18: '无主包裹',
  menu19: '运单详情',
  menu20: '账单详情',
  menu21: '异常件',
  menu22: '异常件详情',
  menu23: '售后服务反馈',
  menu24: '编辑反馈',
  menu25: '反馈详情',
}

t.goods = {
  goods1: '商品编号',
  goods2: '商品名称',
  goods3: '待审核',
  goods4: '已审核',
  goods5: '已驳回',
  goods6: '商品海关分类',
  goods7: '商品中文名',
  goods8: '规格',
  goods9: '商品单价',
  goods10: '单位',
  goods11: '产地',
  goods12: '您是否审核通过商品',
  goods13: '驳 回',
  goods14: '同 意',
  goods15: '审核成功',
  goods16: '请输入商品编码查询系统中是否存在此商品资料',
  goods17: '商品条码',
  goods18: '必填信息',
  goods19: '商品条码',
  goods20: '主图图片',
  goods21: '请选择',
  goods22: '商品英文名',
  goods23: '品牌中文',
  goods24: '中文品名',
  goods25: '规格',
  goods26: '净重',
  goods27: '人民币单价',
  goods28: '其他信息',
  goods29: '原产国商品名',
  goods30: '原产国品牌名',
  goods31: '品牌英文',
  goods32: '英文品名',
  goods33: '原产国单价',
  goods34: '原产国价格，如日元、美元等',
  goods35: '面膜数量',
  goods36: '申报数量',
  goods37: '币制',
  goods38: '请选择币种',
  goods39: '商品税费',
  goods40: '更多信息',
  goods41: '中国海关HS CODE税号',
  goods42: '计量单位',
  goods43: '原产国',
  goods44: '原产国海关HS CODE',
  goods45: '工厂码',
  goods46: '成分',
  goods47: '商品网址',
  goods48: '备注',
  goods49: '系统中存在已审核的该条码的商品，请勿重复添加！',
  goods50: '系统中存在',
  goods51: '的该条码的商品，是否确认编辑?',
  goods52: '审核确认',
  goods53: '已通过',
  goods54: ['美元', '円', '欧元', '加元', '澳元', '港元', '韩元'],
}

t.loginR = {
  login1: '忘记密码',
  login2: '没有账号，现在去',
  login3: '激活成功',
  login4: '您已成功注册账户，请登录',
  login8: '立即免费注册',
  login9: '请输入邮箱',
  login10: '确认密码',
  login11: '注册即表示你同意遵守《用户协议》《隐私政策》',
  login12: '返回登录',
  login13: '提交成功',
  login14: '我们已向您的邮箱发送的激活邮件，请查收邮件并按照说明激活您的账号',
  login15: '去登陆',
  login16: '请输入密码',
  login17: '请再次输入密码',
  login18: '两次输入密码不一致!',
  login19: '注册时必须同意协议',
  login20: '请输入正确的邮箱地址',
  login21: '长度在 6 到 20 个字符',
  login22: '邮箱验证',
  login23: '身份验证',
  login24: '流程说明',
  login25: '完成',
  login26: '下一步',
  login27: '邮箱验证码',
  login28: '恭喜您，新登录密码设置成功',
  login29: '点击下方按钮，或',
  login30: '立即登录',
  login31: '重新发送',
  login32: '发送',
  login33: '秒',
  login34: '重发',
  login35: '秒内后自动返回',
  login36: '请输入6-20位登录名',
  login37: '请输入姓名',
  login38: '最多录入50个字符',
  login39: '网站信息未完善，无法注册',
  login40: '登录名',
  login41: '姓名',
  login42: '邮箱',
  login43: '验证码',
  login44: '确认密码',
  login45: '免费账户注册'
}

t.feedback = {
  feedback1: '提交反馈',
  feedback2: '问题类型',
  feedback3: '创建时间',
  feedback4: '确定要取消该反馈吗？', //
  feedback5: '请选择反馈内容', //
  feedback6: '请输入运单号', //
  feedback7: '问题描述',
  feedback8: '请描述您的问题，我们会尽快和您沟通解决', //
  feedback9: '图片',
  feedback10: '验证码',
  feedback11: '请输入正确的验证码',
  feedback12: '请选择问题类型', //
  feedback13: '请输入运单编号', //
  feedback14: '请输入问题描述', //
  feedback15: '验证码输入错误', //
  feedback16: '当前进度',
  feedback17: '处理说明', //
  feedback18: '返回列表', //
  feedback19: '经协商，为用户提供赔偿', //
  feedback20: '请填写处理说明', //
  feedback21: '如需修改装箱申请请联系客服。', //
}

t.address = {
  address1: '客户', //
  address2: '客户姓名', //
  address3: '地址关键词', //
  address4: '电话',
  address5: '证件编号',
  address6: '是否默认',
  address7: '默认发货人', //
  address8: '默认收货人', //
  address9: '地址',
  address10: '地区',
  address11: '收货人',
  address12: '发货人',
  address13: '收货人，发货人',
  address14: '编辑地址', //
  address15: '新增地址',
  address16: '地址详情', //
  address17: '确定要删除该地址吗？', //
  address18: '收货地址', //
  address19: '姓名',
  address20: '邮编',
  address21: '邮箱',
  address22: '国家', //
  address23: '请选择国家', //
  address24: '请选择地区', //
  address25: '详细地址',
  address26: '详细地址、街道、门牌号等',
  address27: '身份证正面',
  address28: '身份证反面',
  address29:
    '建议上传图片尺寸为600px*600px，请准确上传。我们将通过 公安系统比对身份信息',
  address30: '收/发货人',
  address31: '设为默认收货人',
  address32: '设为默认发货人',
  address33: '请输入证件编号', //
  address34: '请输入电话', //
  address35: '请输入邮编', //
  address36: '请选择国家', //
  address37: '请输入详细地址', //
  address38: '请选择', //
  address39: '请输入姓名', //
  address40: '请输入邮箱', //
  address41: '请输入备注', //
  address42: '模板下载', //
  address43: '浏览',
}

t.excel = {
  excel1: '模板下载',
  excel2: '浏览',
  excel3: '请上传xls文件',
  excel4: '收费项目',
  excel5: '价格（元）',
  excel6: '价格',
  excel7: '数量',
  excel8: '应付金额',
  excel9: '未提交',
  excel10: '审核通过',
  excel11: '审核失败',
  excel12: '操作手册',
  excel13: '收费说明',
  excel14: '详细检品指示书',
}

t.photo = {
  photo1: '上传图片只支持jpg、jpeg、png格式!',
  photo2: '请上传小于5M的图片',
}
t.accountInformation = {
  accountInformation1: '用户ID',
  accountInformation2: '公司名称：',
  accountInformation3: '请输入少于10个字符', //
  accountInformation4: '请输入少于20个字符', //
  accountInformation5: '会社/请输入公司/店铺名称', //
  accountInformation6: '常用地址',
  accountInformation7: '自动付款',
  accountInformation8: '开启', //
  accountInformation9: '关闭', //
  accountInformation10: '姓名最长10个字符',
  accountInformation11: '公司名最长20字符',
}

t.changeAccount = {
  changeAccount1: '您当前的账号是',
  changeAccount2: '绑定邮箱',
  changeAccount3: '当前绑定邮箱',
  changeAccount4: '若邮箱丢失或停用，请及时更换', //
  changeAccount5: '更换邮箱',
  changeAccount6: '登录密码',
  changeAccount7: '建议您定期更换密码，可以使帐号更安全',
  changeAccount8: '更换密码',
  changeAccount9: '更换邮箱账号',
  changeAccount10: '身份验证',
  changeAccount11: '更换邮箱账号',
  changeAccount12: '完成',
  changeAccount13: '请输入验证码',
  changeAccount14: '获取验证码',
  changeAccount15: '请输入正确的验证码',
  changeAccount16: '验证码发送成功', //
  changeAccount17: '下一步',
  changeAccount18: '请输入新的邮箱账号',
  changeAccount19: '输入正确的邮箱格式', //
  changeAccount20: '返回',
  changeAccount21: '恭喜你更换邮箱号成功',
  changeAccount22: '点击下方按钮或',
  changeAccount23: '秒后返回',
  changeAccount24: '恭喜你密码设置成功',
  changeAccount25: '请上传xls文件', //
  changeAccount26: '修改登录密码', //
  changeAccount27: '设置6-16位新登录密码',
  changeAccount28: '确认6-16位新登录密码',
  changeAccount29: '请输入密码', //
  changeAccount30: '两次输入的的密码请保持一致',
  changeAccount31: '长度在 6 到 20 个字符',
  changeAccount32: '绑定手机号',
  changeAccount33: '若手机号停用，请及时更换',
  changeAccount34: '更换手机号',
  changeAccount35: '修改登录邮箱',
  changeAccount36: '秒',
  changeAccount37: '可重发',
  changeAccount38: '请输入新邮箱',
  changeAccount39: '新邮箱修改成功',
  changeAccount40: '温馨提示',
  changeAccount41: '为保障您的帐号安全，变更重要信息需要身份验证',
  changeAccount42: '若有疑问请联系在线客服或拨打',
  changeAccount43: '不能与已绑邮箱相同',
  changeAccount44: '发送验证码',
  changeAccount45: '更换登录手机号',
  changeAccount46: '请输入要更改的手机号',
  changeAccount47: '手机号不能为空',
  changeAccount48: '手机号格式不正确',
  changeAccount49: '不能与已绑手机号相同',
  changeAccount50: '新手机号设置成功',
  changeAccount51: '请输入6位大小写字母、数字中的两种',
  changeAccount52: '新登录密码设置成功，请重新进行登录',
  changeAccount53: '点击下方按钮',
  changeAccount54: '或',
  changeAccount55: '秒后自动返回',
}

t.capitalflow = {
  capitalflow1: '交易金额',
  capitalflow2: '交易时间',
  capitalflow3: '交易对方',
  capitalflow4: '可用余额(日元)',
  capitalflow5: '充值',
  capitalflow6: '退金（提现）', //
  capitalflow7: '运单付款', //
  capitalflow8: '运单收款', //
  capitalflow9: '物流付款', //
  capitalflow10: '物流收款', //
  capitalflow11: '扣款', //
  capitalflow12: '赔偿', //
  capitalflow13: '退款', //
  capitalflow14: '服务费', //
  capitalflow15: '充值手续费', //
}

t.createOrder = {
  createOrder1: '创建订单', //
  createOrder2: '我的辅料',
  createOrder3: '纸标签',
  createOrder4: '洗涤标签',
  createOrder5: '领标',
  createOrder6: '商品附属品',
  createOrder7: '余额',
  createOrder8: '充值',
  createOrder9: '批量上传',
  createOrder10: '操作',
  createOrder11: '国内运单号',
  createOrder12: '【淘宝/1688】商品链接',
  createOrder13: '商品信息',
  createOrder14: '名称：',
  createOrder15: '数量：',
  createOrder16: '单价：',
  createOrder17: '颜色：',
  createOrder18: '尺寸：',
  createOrder19: 'SKU：',
  createOrder20: '上传',
  createOrder21: '代为购买',
  createOrder22: 'PDF/AI文件',
  createOrder23: 'FBA/YFF/RSL',
  createOrder24: '编号',
  createOrder25: '检品选项',
  createOrder26: '水洗标模板',
  createOrder27: '包装意向',
  createOrder28: '发件人信息',
  createOrder29: '姓名：',
  createOrder30: '电话：',
  createOrder31: '地址：',
  createOrder32: '选择',
  createOrder33: '编辑',
  createOrder34: '收件人信息',
  createOrder35: '邮编：',
  createOrder36: '新增一行',
  createOrder37: '价格：',
  createOrder38: '数量：',
  createOrder39: '默认地址',
  createOrder40: '手机号',
  createOrder41: '选择省/市/区',
  createOrder42: '邮政编码',
  createOrder43: '是否默认地址',
  createOrder44: '输入正确的电话', //
  createOrder45: '请填写货品名称', //
  createOrder46: '请填写货品规格', //
  createOrder47: '请填写数量', //
  createOrder48: '请填写大于0的整数', //
  createOrder49: '请输入正确金额格式', //
  createOrder50: '请填写备注', //
  createOrder51: '选择省', //
  createOrder52: '市', //
  createOrder53: '区/街道', //
  createOrder54: '请填写姓名', //
  createOrder55: '请填写电话', //
  createOrder56: '请填写详细地址', //
  createOrder57: '请填写邮政编码', //
  createOrder58: '袋装',
  createOrder59: '纸箱',
  createOrder60: '鞋盒',
  createOrder61: '特殊箱子',
  createOrder62: '请输入运单号', //
  createOrder63: '请输入正确格式运单号', //
  createOrder64: '请选择地址', //
  createOrder65: '请选择发件人后操作', //
  createOrder66: '请选择收件人后操作', //
  createOrder67: '选择地址', //
  createOrder68: '确定删除该文件？', //
  createOrder69: '已删除', //
  createOrder70: '已取消删除', //
  createOrder71: '确定删除该图片？', //
  createOrder72: '上传文件只能是 PDF 格式!', //
  createOrder73: '上传成功', //
  createOrder74: '请上传jpg,jpeg,png格式的图片！', //
  createOrder75: '上传失败', //
  createOrder76:
    '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！', //
  createOrder77: '最多可上传一张图片', //
  createOrder78: '确定删除本条订单信息?', //
  createOrder79: '最少保留一条数据', //
  createOrder80: '请输数量', //
  createOrder81: '请输颜色', //
  createOrder82: '请输单价', //
  createOrder83: '请输入正确格式运单号', //
  createOrder84: '请输入', //
  createOrder85: '请输入名称', //
  createOrder86: '请输入地址', //
  createOrder87: '请选择水洗标模板', //
  createOrder88: '绿色', //
  createOrder89: '红色', //
  createOrder90: '运单号长度过长', //
  createOrder91: '当前限制选择 1 个文件', //
  createOrder92: '本次选择了', //
  createOrder93: '个文件', //
  createOrder94: '共选择了', //
  createOrder95: '检品文件',
  createOrder96:
    "上传文件只能是 doc、docx、xls、xlsx、ppt、pptx、pdf、txt、jpg、jpeg、png、gif 格式",
  createOrder97: "上传文件大小不能超过 20MB",
  createOrder98: "上传文件只能是 pdf、 ai 格式",
  createOrder99: "订单属性",
  createOrder100: "FBA/YFF/RSL",
  createOrder101: "联系我们",
  createOrder102: "用户ID",
  createOrder103: "消息类型",
  createOrder104: "订单编号",
  createOrder105: "标题",
  createOrder106: "内容",
  createOrder107: "图片",
  createOrder108: "请填写标题",
  createOrder109: "请填写内容",
  createOrder110: "其他类型",
  createOrder111: "用户备注",
  createOrder112: "中国运输",
  createOrder113: "品名：",
  createOrder114: "请输入fnsku品名",
  createOrder115: "请输入中国运费",
  createOrder116: "名称：",
  createOrder117: "上传附件",
  createOrder118: "当前限制选择 9 个文件", //
  createOrder119: "当前限制选择 3 个文件",
  batchDelete: "批量删除",
  confirmDelete: "确认删除吗？",
  specialChar: "文件名中不能包含以下字符 ，；：｛｝* 请检查后修改文件名后再上传",
  createOrder120: "序号",
  createOrder121: "选择",
  createOrder122: 'SKU：',
  createOrder123: '冻结金额',
  createOrder125: '请选择颜色和尺寸',
  createOrder127: '商品备注',
  createOrder128: '客户备注'
};

t.orderList = {
  orderList1: "订单列表", //
  orderList2: "订单编号", //
  orderList3: "请输入内容",
  orderList4: "国际运单号",
  orderList5: "国内运单号",
  orderList6: "待购买",
  orderList7: "购买完",
  orderList8: "等待到库",
  orderList9: "已到库",
  orderList10: "仓库保管中",
  orderList11: "待支付",
  orderList12: "不良订单",
  orderList13: "已完成",
  orderList14: "复制",
  orderList15: "排序",
  orderList16: "退货",
  orderList17: "取消退货",
  orderList18: "销毁",
  orderList19: "取消销毁",
  orderList20: "拆单",
  orderList21: "账单",
  orderList22: "支付",
  orderList23: "提醒",
  orderList24: "不良订单",
  orderList25: "请输入国内运单号", //
  orderList26: "颜色",
  orderList27: "尺寸",
  orderList28: "商品SKU",
  orderList29: "商品数量",
  orderList30: "待装箱数",
  orderList31: "退货数量",
  orderList32: "销毁数量",
  orderList33: "申请发货",
  orderList34: "不良待处理",
  orderList35: "补发中",
  orderList36: "换货中",
  orderList37: "原订单信息", //
  orderList38: "原订单编号",
  orderList39: "原订单状态",
  orderList40: "原订单数量",
  orderList41: "原订单退货数",
  orderList42: "原订单销毁数",
  orderList43: "原订单是否FBA",
  orderList44: "原订单仓库保管",
  orderList45: "拆单信息", //
  orderList46: "订单状态",
  orderList47: "是否免费仓储",
  orderList48: "退货数",
  orderList49: "销毁数",
  orderList50: "消息类型：",
  orderList51: "订单消息", //
  orderList52: "订单编号：",
  orderList53: "标题：",
  orderList54: "内容：",
  orderList55: "图片：",
  orderList56: "数量应大于0小于原数量",
  orderList57: "请输入数量", //
  orderList58: "退货数应大于等于0小于等于原退货数", //
  orderList59: "请输入退货数", //
  orderList60: "销毁数应大于等于0小于等于原销毁数", //
  orderList61: "请输入销毁数", //
  orderList62: "请输入标题",
  orderList63: "请输入回复内容",
  orderList64: "到库",
  orderList65: "检品中",
  orderList66: "检品完",
  orderList67: "不良驳回", //
  orderList68: "换货待发回", //
  orderList69: "换货等待到货", //
  orderList70: "待部分退货", //
  orderList71: "补发等待到货", //
  orderList72: "待发送",
  orderList73: "已发送",
  orderList74: "退货申请中", //
  orderList75: "退货待支付", //
  orderList76: "待退货", //
  orderList77: "已退货", //
  orderList78: "销毁申请中", //
  orderList79: "销毁待支付", //
  orderList80: "待部分销毁", //
  orderList81: "已销毁", //
  orderList82: "装箱中",
  orderList83: "保存成功", //
  orderList84: "保存失败", //
  orderList85: "请选中要复制的订单",
  orderList86: "确认取消退货申请吗？取消后订单将回退到申请退货时的状态。",
  orderList87: "已取消退货",
  orderList88: "确认申请退货吗？申请退货可能产生退货费用，工作人员收到申请后会发送账单，您支付成功后便可成功退货。",
  orderList89: "销毁可能产生异常处理费，确认销毁吗？", //
  orderList90: "销毁可能产生异常处理费，确认销毁吗？", //
  orderList91: "销毁成功", //
  orderList92: "已取消销毁",
  orderList93: "确认取消销毁商品订单吗？取消后订单将回退到申请销毁时的状态。",
  orderList94: "确定把此订单设为仓库保管订单吗？",
  orderList95: "仓库保管成功", //
  orderList96: "已取消仓库保管", //
  orderList97: "确定申请发货吗？",
  orderList98: "申请发货",
  orderList99: "申请发货成功",
  orderList100: "已取消申请发货",
  orderList101: "确认取消订单吗？",
  orderList102: "取消订单",
  orderList103: "已取消取消订单",
  orderList104: "必填项不能为空，请重新填写并提交！", //
  orderList105: "请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！", //
  orderList106: "最多可上传1张图片", //
  orderList107: "确定移除", //
  orderList108: "已打包", //
  orderList109: "无法购买", //
  orderList110: "退货可能产生退货费用，确认申请退货吗？",
  orderList111: "待销毁",
  orderList112: "运单状态",
  orderList113: "全部",
  orderList114: "到库",
  orderList115: "检品中",
  orderList116: "待发送",
  orderList117: "装箱中",
  orderList118: "单价",
  orderList119: "中国运费",
  orderList120: "当前订单待付金额",
  orderList121: "元",
  orderList122: "费用导出",
  orderList123: "重新计算",
  orderList124: "计算费用",
  orderList125: "请选择至少一个订单",
  orderList126: "待申请发送",
  orderList127: "到库",
  orderList128: "检品完",
  orderList129: "可申请装箱",
  orderList130: "净重",
  orderList131: "您选择了共",
  orderList132: "条订单，确认计算他们的费用吗？",
  orderList133: "当前未选择任何订单，将计算当前列表所有订单的费用，共计",
  orderList134: "条，需要一定加载时间，确认计算吗？",
  orderList135: "订单数量",
  addCart: "加入购物车",
  orderList136: "补发中",
  orderList137: "只能上传excel、pdf文件和ai文件",
  orderList138: "最多可上传9张图片", //
  orderList139: "清空数量提示",
  orderList140: "免费保管中：剩余",
  orderList141: "保管费用：",
  orderList142: "已保管",
  orderList143: "最多可上传5个附件",
  orderList144: "生成中",
  orderList145: "已生成",
  orderList146: "查看",
  orderList147: "下载",
  orderList148: "总数量",
  orderList149: "已装箱",
  orderList150: "待装箱",
  orderList151: "退货",
  orderList152: "销毁",
  orderList153: "可装箱",
  orderList154: "已发送",
  orderList155: "是否确认清空状态下数量的显示（只数量显示，不影响商品状态）",
  orderList156: "列表调整",
  orderList157: "批量取消",
  orderList158: "是否确认清除 [无法购买] 计数统计?",
  orderList159:'①列表调整',
  orderList160:'显示的内容',
  orderList161:'隐藏的内容',
  orderList162:'1.左边列是要显示内容，右边列是要隐藏的内容，将字段从左边列移到右边列就可以隐藏;',
  orderList163:'2.左边列可以用鼠标上下拖动位置，用来调整他们的排列顺序;',
  orderList164:'3.调整完成之后请记得保存;',
  orderList165:'已清除',
  orderList166:'清除失败',
  orderList167:'未知错误',
  orderList168:'已取消操作',
  orderList169:'发生错误',
  orderList170: "是否确认取消所选订单?",
  orderList171: "代购买（商品数量*单价）+中国运费+检品费（费用*商品数量）",
  orderList172: "购买完   检品费（费用*商品数量）",
  orderList175: "是否免费仓储"
};

t.OrderDetail = {
  OrderDetail1: '订单信息', //
  OrderDetail2: '创建日期',
  OrderDetail3: '同捆',
  OrderDetail4: '不良处理中数量',
  OrderDetail5: '箱子类型',
  OrderDetail6: 'opp袋类型',
  OrderDetail7: '到货日期', //
  OrderDetail8: '换货中数量',
  OrderDetail9: '抛重',
  OrderDetail10: 'OPP袋数',
  OrderDetail11: '发送日期',
  OrderDetail12: '补发中数量',
  OrderDetail13: '实重',
  OrderDetail14: '国际物流状态',
  OrderDetail15: '图片链接',
  OrderDetail16: '用户备注',
  OrderDetail17: '商品链接',
  OrderDetail18: '地址信息', //
  OrderDetail19: '进口商',
  OrderDetail20: '收件人邮编',
  OrderDetail21: '进口商电话',
  OrderDetail22: '收件人电话',
  OrderDetail23: '地址编号',
  OrderDetail24: '进口商地址',
  OrderDetail25: '收件人地址',
  OrderDetail26: '收费信息（元，实际收费以账单为准）',
  OrderDetail27: '国际运费',
  OrderDetail28: '印刷费',
  OrderDetail29: '代购手续费',
  OrderDetail30: '合计',
  OrderDetail31: '箱费',
  OrderDetail32: '退货运费',
  OrderDetail33: '退货手续费',
  OrderDetail34: '基础检品费',
  OrderDetail35: '仓库保管费',
  OrderDetail36: '销毁手续费',
  OrderDetail37: 'opp袋费',
  OrderDetail38: '检品费',
  OrderDetail39: '标签费',
  OrderDetail40: '国内运费',
  OrderDetail41: '订单详情', //
  OrderDetail42: '必填', //
  OrderDetail43: '数量只能填写数字', //
  OrderDetail44: '只能为数字且最多保留小数点后两位', //
  OrderDetail45: '请检查必填项或填写格式', //
  OrderDetail46: '编辑订单', //
  OrderDetail47: '商品费', //
  OrderDetail49: '异常处理费', //
  OrderDetail50: 'NO', //
  OrderDetail51: '商品名', //
  OrderDetail52: '中国运单号', //
  OrderDetail53: '用户备注', //
  OrderDetail54: '图片', //
  OrderDetail55: '品名', //
  OrderDetail56: '进口商邮编',
  OrderDetail57: '检品视频',
  OrderDetail58: '换回详细检品费',
  OrderDetail59: '操作日志',
  OrderDetail60: '操作前状态',
  OrderDetail61: '操作后状态',
  OrderDetail62: '操作节点',
  OrderDetail63: '操作详情',
  OrderDetail64: '操作时间',
  OrderDetail65: '手机号',
  OrderDetail66: '检品项',
  OrderDetail68: '检品图片',
  OrderDetail69: '检品信息',
}

t.OrderBill = {
  OrderBill1: '账单类型',
  OrderBill2: '账单编号',
  OrderBill3: '项目',
  OrderBill4: '单价',
  OrderBill5: '优惠/折扣',
  OrderBill6: '金额',
  OrderBill7: '付款总金额',
  OrderBill8: '当前余额',
  OrderBill9: '余额不足，请先充值', //
  OrderBill10: '支付国际运费', //
  OrderBill11: '去充值', //
  OrderBill12: '确认支付订单吗？', //
  OrderBill13: '已取消支付', //
  OrderBill14: '确认关闭？', //
  OrderBill15: '订单操作',
  OrderBill16: '国内物流',
  OrderBill17: '国际物流',
  OrderBill18: '检品',
  OrderBill19: '不良数量',
  OrderBill20: '付款时间',
  OrderBill21: '检品视频',
  OrderBill22: '播放',
  OrderBill23: '检品报告书',
}

t.arrivalOrder = {
  arrivalOrder1: '到货订单',
  arrivalOrder2: '请输入订单号', //
  arrivalOrder3: '退货成功', //
}

t.inStorageOrder = {
  inStorageOrder1: '仓库保管订单',
  inStorageOrder2: '请输入收件人', //
  inStorageOrder3: '批量发货',
  inStorageOrder4: '排序',
  inStorageOrder5: '至少选择一条数据',
  inStorageOrder6: '确认批量申请发货吗？',
  inStorageOrder7: '批量申请发货', //
  inStorageOrder8: '是否免仓储费', //
  inStorageOrder9: '仓储开始时间', //
  inStorageOrder10: '计费开始时间', //
  inStorageOrder11: '发送时间', //
  inStorageOrder12: '仓储时长(天)', //
  inStorageOrder13: '仓储费小计(￥)', //
  inStorageOrder14: '仓储费明细', //
  inStorageOrder15: '本批次仓储费用合计(￥)', //
  inStorageOrder16: '异常单号/原因/方案', //
  inStorageOrder17: '数量（件）', //
}
t.laund = {
  laund1: 'TOP',
  laund2: '水洗标模板管理',
  laund3: '模板名称',
  laund4: '请输入模板名称',
  laund5: '重置',
  laund6: '搜索',
  laund7: '新建模板',
  laund8: '复制',
  laund9: '编辑',
  laund10: '删除',
  laund11: '尺寸',
  laund12: '材质',
  laund13: '洗涤注意图标',
  laund14: '使用注意事项',
  laund15: '公司名',
  laund16: '电话号码',
  laund17: '邮件',
  laund18: '创建时间',
  laund19: '备注',
  laund20: '编辑模板',
  laund21: '复制模板',
  laund22: '确定删除该模板？',
  laund23: '提交',
  laund24: '取消',
  laund25: '已取消删除',
  laund26: '字符数：',
  laund27: '行数：',
  laund28: '使用注意事项',
  laund29: '公司名',
  laund30: '联系电话',
  laund31: '洗涤符号',
  laund32: '水洗符号：',
  laund33: '漂白符号：',
  laund34: '干燥符号：',
  laund35: '翻转干燥符号：',
  laund36: '熨烫符号：',
  laund37: '干洗处理符号：',
  laund38: '湿洗处理符号：',
  laund39: '模板预览：',
  laund40: '超过最大行数！',
  laund41: '请输入正确的邮箱格式！',
  laund42: '水洗标模板名称不可以重复，请修改！',
  laund43: '保存失败',
  laund44: '请选中或取消选中相应符号以添加到模板或从模板移除。',
  laund45: '此项目为必填项！',
  laund46: '收件人地址',
}
t.defe = {
  defe1: '不良件详情',
  defe2: '请输入内容',
  defe3: '创建时间:',
  defe4: '选择时间',
  defe5: '处理时间:',
  defe6: '处理方式:',
  defe7: '重发运单号:',
  defe8: '发回运单号:',
  defe9: '请输入内容',
  defe10: '全部',
  defe11: '待处理',
  defe12: '处理中',
  defe13: '处理完',
  defe14: '已取消',
  defe15: '重置',
  defe16: '搜索',
  defe17: '排序',
  defe18: '详情',
  defe19: '换货',
  defe20: '补发',
  defe21: '部分退货',
  defe22: '全部退货',
  defe23: '部分销毁',
  defe24: '全部销毁',
  defe25: '正常发送',
  defe26: '商品详情',
  defe27: '破损：',
  defe28: '脏污：',
  defe29: '错款：',
  defe30: '少数：',
  defe31: '添加',
  defe32: '换货数量：',
  defe33: '退货数量',
  defe34: '退货数',
  defe35: '补发数量',
  defe36: '重发运单号：',
  defe37: '销毁数量',
  defe38: '销毁数',
  defe39: '退货地址',
  defe40: '处理说明',
  defe41: '序号',
  defe42: '添加人',
  defe43: '添加时间',
  defe44: '内容',
  defe45: '关闭',
  defe46: '添加说明',
  defe47: '换货数量不能为空',
  defe48: '补发数量不能为空',
  defe49: '退货数量不能为空',
  defe50: '销毁数量不能为空',
  defe51: '处理说明不能为空',
  defe52: '保存成功',
  defe53: '保存失败',
  defe54: '必填项不能为空，请重新填写并提交！',
  defe55: '换货',
  defe56:
    '如果您当前没有重发运单号，请务必在卖家发货后补录入重发运单号。如果是非代购订单，请务必填写退货地址。',
  defe57: '如果您当前没有重发运单号，请务必在卖家发货后补录入重发运单号。',
  defe58: '补发',
  defe59: '如果是非代购订单，请务必填写退货地址。',
  defe60: '部分退货',
  defe61: '部分销毁',
  defe62: '如果是非代购订单，请务必填写退货地址。',
  defe63: '全部退货',
  defe64: '全部销毁',
  defe65: '正常发送',
  defe66: '选择正常发货后，意味着您接受不良品发送到目的地。',
  defe67: '操作',
  defe68: '处理方式',
  defe69: '不良件编号',
  defe70: '创建时间',
  defe71: '数量',
  defe72: '图片1',
  defe73: '不良图片',
  defe74: '不良情况',
  defe75: '不良描述',
  defe76: '处理说明',
  defe77: '处理状态',
  defe78: '处理日期',
  defe79: '发回运单号',
  defe80: '重发运单号',
  defe81: '退货地址',
  defe82: '数量：',
  defe83: '退货运费：',
  defe84: '发回运单号：',
  defe85: '状态：',
  defe86: '不良数量：',
  defe87: '退货手续费：',
  defe88: '重发运单号：',
  defe89: '创建时间：',
  defe90: '处理时间：',
  defe91: '销毁手续费：',
  defe92: '退货地址：',
  defe93: '不良描述：',
  defe94: '处理说明：',
  defe95: '点击上传',
  defe96: '订单详情',
  defe97: '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！',
  defe98: '最多可上传3张图片',
  defe99: '不良数量',
  defe100: '异常处理费',

  defe101: '更换',
  defe102: '退货',
  defe103: '库存化',
  defe104: '希望处理方式：',
}

t.addr = {
  addr1: "地址管理",
  addr2: "收货地址",
  addr3: "进口商地址",
  addr4: "姓名",
  addr5: "请输入收货人",
  addr6: "重置",
  addr7: "搜索",
  addr8: "新建地址",
  addr9: "序号",
  addr10: "操作",
  addr11: "编辑",
  addr12: "删除",
  addr13: "地址编号",
  addr14: "默认地址",
  addr15: "收货人",
  addr16: "电话",
  addr17: "地区",
  addr18: "详细地址",
  addr19: "邮编",
  addr20: "备注",
  addr21: "新建/编辑地址",
  addr22: "进口商姓名",
  addr23: "请输入进口商姓名",
  addr24: "进口商电话",
  addr25: "请输入进口商电话",
  addr26: "地址",
  addr27: "选择省/市/区",
  addr28: "邮政编码",
  addr29: "详细地址",
  addr30: "详细地址，街道，门牌号等",
  addr31: "是否默认地址",
  addr32: "请输入姓名",
  addr33: "请输入电话",
  addr34: "请输入详细地址",
  addr35: "请输入邮编",
  addr36: "请输入地址编号",
  addr37: "请选择区域",
  addr38: "必填项不能为空，请重新填写并提交！",
  addr39: "确定删除改地址？",
  addr40: "已取消删除",
  addr41: "公司名",
  addr42: "法人编号",
  addr43: "Naccs实时帐户",
  addr44: "Email",
  addr45: "请输入公司名",
  addr46: "请输入法人编号",
  addr47: "请输入Naccs实时帐户",
  addr48: "请输入Email",
  addr49: "已选商品数量",
  addr50: "商品总净重",
  addr51: "名称",
  addr52: "申请数量总数",
};
t.mess = {
  mess1: '收件箱',
  mess2: '发件箱',
  mess3: '关联单号',
  mess4: '消息类型',
  mess5: '发送开始日',
  mess6: '选择日期',
  mess7: '发送结束日',
  mess8: '全部',
  mess9: '未读',
  mess10: '已读',
  mess11: '重置',
  mess12: '搜索',
  mess13: '全部已读',
  mess14: '序号',
  mess15: 'Re',
  mess16: '消息状态',
  mess17: '图片',
  mess18: '消息类型',
  mess19: '关联单号',
  mess20: '发送时间',
  mess21: '标题',
  mess22: '内容',
  mess23: '消息类型：',
  mess24: '订单编号：',
  mess25: '标题：',
  mess26: '回复内容：',
  mess27: '图片：',
  mess28: '点击上传',
  mess29: '请输入标题',
  mess30: '请输入回复内容',
  mess31: '订单消息',
  mess32: '其他消息',
  mess33: '请选择',
  mess34: '已回复',
  mess35: '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！',
  mess36: '最多可上传1张图片',
  mess37: '必填项不能为空，请重新填写并提交！',
  mess38: '未回复',
  mess39: '已选择列',
  mess40: '到左边',
  mess41: '到右边',
  mess42: '未选择列',
  mess43: '排序',
  mess44: '确认关闭？',
  mess45: '附件',
  mess46: '历史对话',
  mess47: '发送人',
  mess48: '我',
  mess49: '平台',
  mess50: '已回复',
  mess51: '消息回复',
  mess52: '最多可上传1张图片',
  mess53: '收藏夹',
  mess54: '收藏',
  mess55: '取消收藏',
  mess56: '普通消息',
  mess57: '订单修改',
  mess58: '批次消息',
  mess59: '最多可上传9张图片',
  mess60: '已读未回复',
  mess61: '不良消息',
  mess62: '输入关键字进行搜索',
  mess63: '关联订单/批次',
  mess64: '不限',
  mess65: '发送于',
  mess66: '暂无消息',
  mess67: '接收人',
  mess68: '无',
  mess69: '关联批次',
  mess70: '之前的对话记录',
  mess71: '已收藏',
  mess72: '当前限制选择 9 个文件',
  mess73: '请上传图片、视频、excel、ai和pdf文件',
  mess74: '消息发送成功',
  mess75: '暂无对话',
  mess76: '发消息',
  mess77: '平台',
  mess78: '只能输入数字和字母',
  mess79: '回复',
  mess80: '订单号不存在',
  mess81: '接口异常',
  mess82: '关键字'
};
t.badOrder = {
  badOrder1: '退货中',
  badOrder2: '销毁中',
  badOrder3: '不良详情',
}

t.BuddleOrderDetail = {
  BuddleOrderDetail1: '下单开始日', //
  BuddleOrderDetail2: '选择日期', //
  BuddleOrderDetail3: '发送开始日',
  BuddleOrderDetail4: '发送结束日',
  BuddleOrderDetail5: '下单日',
  BuddleOrderDetail6: '到库日',
  BuddleOrderDetail7: '发送日',
  BuddleOrderDetail8: '商品URL',
  BuddleOrderDetail9: '同捆列表详情', //
  BuddleOrderDetail10: '用户', //
}

t.BuddleOrder = {
  BuddleOrder1: '已到齐',
  BuddleOrder2: '发送中',
  BuddleOrder3: '已取消修改',
  BuddleOrder4: '修改成功', //
  BuddleOrder5:
    '确定申请发货此同捆批次吗？这会把同捆状态改为【申请发货】，之后不会再有新的订单进入此同捆', //
  BuddleOrder6: '发货', //
  BuddleOrder7: '订单号',
  BuddleOrder8: '同捆到货数',
  BuddleOrder9: '同捆数', //
  BuddleOrder10: '收件地址',
  BuddleOrder11: '收件信息',
  BuddleOrder12: '同捆发送日',
  BuddleOrder13: '同捆状态',
  BuddleOrder14: '同捆创建时间',
  BuddleOrder15: '同捆编号',
  BuddleOrder16: '发货申请',
  BuddleOrder17: '同捆详情',
  BuddleOrder18: '等待到货',
  BuddleOrder19: '同捆列表',
  BuddleOrder20: '已选择列',
  BuddleOrder21: '到右边',
  BuddleOrder22: '未选择列',
  BuddleOrder23: '到左边',
  BuddleOrder24: '支付账单', //
  BuddleOrder25: '拆分同捆', //
  BuddleOrder26: '国际物流', //
}

t.payBills = {
  payBills1: '转送', //
  payBills2: '装箱', //
  payBills3: '同捆', //
  payBills4: '付款总额', //
  payBills5: '已支付', //
  payBills6: '您的账户余额不足，请充值后支付', //
  payBills7:
    '如果您想在订单处理到以下节点时接收到Email通知，请选中相应节点，并点击保存',
  payBills8: '提醒节点', //
  payBills9: '收信Email', //
  payBills10: '购买完', //
  payBills11: '无法购买', //
  payBills12: '店铺发货', //
  payBills13: '到库', //
  payBills14: '开始检品', //
  payBills15: '检品完', //
  payBills16: '产生不良', //
  payBills17: '不良处理完', //
  payBills18: '收到账单', //
  payBills19: '批次发货', //
  payBills20: 'Email提醒', //
  payBills21: '收到人工消息', //
}

t.router = {
  router1: '新建订单',
  router2: '发货单', //
  router3: 'FBA新建装箱单', //
  router4: 'FBA账单', //
  router5: '资金明细',
  router6: '消息列表', //
  router7: '充值记录',
  router8: '个人资料',
  router9: '账号安全',
  router10: '修改登录手机号',
  router11: '装箱单详情', //
  router12: '箱子详情', //
  router13: '不良件货库详情', //
  router14: '提醒设置', //
  router15: '新订单',
  router16: '隐私政策',
}

t.filter = {
  filter1: '待购买',
  filter2: '购买完',
  filter3: '等待到库',
  filter4: '到库',
  filter5: '检品中',
  filter6: '检品完',
  filter7: '仓库保管中',
  filter8: '申请发货',
  filter9: '不良待处理',
  filter10: '不良驳回',
  filter11: '换货待发回',
  filter12: '换货等待到货',
  filter13: '待部分退货',
  filter14: '补发等待到货',
  filter15: '待支付',
  filter16: '待发送',
  filter17: '已发送',
  filter18: '已取消',
  filter19: '退货申请中',
  filter20: '退货待支付',
  filter21: '待退货',
  filter22: '已退货',
  filter23: '销毁申请中',
  filter24: '销毁待支付',
  filter25: '待部分销毁',
  filter26: '待销毁',
  filter27: '已销毁',
  filter28: '检品完',
  filter29: '无法购买',
  filter30: '转送',
  filter31: '装箱',
  filter32: '袋装',
  filter33: '纸箱',
  filter34: '鞋盒',
  filter35: '特殊箱子',
  filter36: '否',
  filter37: '是',
  filter38: '换标签',
  filter39: '剪领标',
  filter40: '换领标',
  filter41: '剪水洗标',
  filter42: '换水洗标',
  filter43: '打孔',
  filter44: '消臭',
  filter45: '干燥剂',
  filter46: '商品+1点',
  filter47: '换尺寸标签',
  filter48: '商品+2点',
  filter49: '商品+其他附属品',
  filter50: '未盘点',
  filter51: '盘点通过',
  filter52: '盘点未通过',
  filter53: '装箱',
  filter54: '订单',
  filter55: '询价中',
  filter56: '待支付',
  filter57: '待付款',
}
t.select = {
  select1: '选择商品',
  select2: '已选中',
  select3: '货品名称',
  select4: '订单编号',
  select5: '搜索',
  select6: '重置',
  select7: '订单编号',
  select8: '商品名称',
  select9: '下单日',
  select10: '到库日',
  select11: '订单状态',
  select12: '暂无选择',
  select13: '请选择已有同捆',
  select14: '同捆编号',
  select15: '同捆创建时间',
  select16: '收件人',
  select17: '同捆状态',
  select18: '拆分到已有同捆',
  select19: '拆分到新的同捆',
  select20: '操作成功',
  select21: '请选择已有同捆',
  select22: '请先选择',
  select23: '请先选择商品',
  select24: '暂无数据',
}

t.store = {
  store1: '全部订单',
  store2: 'FBA装箱批次',
  store3: '账户充值', //
  store4: '售后反馈',
  store5: '消息提醒',
  store6: '水洗标模板管理',
}

t.login = {
  login1: "登录ID",
  login2: "登录",
  login3: "请输入用户名", //
  login4: "登录成功", //
  login5: "重置密码", //
  login6: "设置新密码", //
  login7: "请输入注册邮箱", //
  login8: "接收信息邮箱", //
  login9: "设置6-20位登录密码", //
  login10: "重复设置6-20位登录密码", //
  login11: "密码不能为空", //
  login12: "密码长度应为6-16位", //
  login13: "请输入大小写字母和数字中的至少两种", //
  login14: "确认密码不能为空", //
  login15: "两次密码输入不相同", //
  login16: "验证码不能为空", //
  login17: "验证码格式不正确", //
  login18: "已发送，请查收信息", //
  login19: "邮箱不能为空", //
  login20: "邮箱格式不正确", //
  login21: "请输入6-20位密码", //
  login22: "请再次输入密码", //
  login23: "同意", //
  login24: "用户服务协议", //
  login25: "免费注册", //
  login26: "已有账号，现在去登录", //
  login27: "请同意《用户协议》", //
  login28: "支持6-20位英文/数字/英文+数字组合，请输入正确的格式", //
  login29: "请输入正确的格式", //
  login30: "请输入手机号码", //
  login31: "请输入正确格式", //
  login32: "请重新输入密码", //
  login33: "注册成功", //
  login34: "操作失败", //
  login35: "记住密码", //
  login36: "隐私政策", //
  login37: "请同意《隐私政策》", //
  login38: "密码长度6-20位，仅可使用英文字母及数字", //
  login39: "我们对使用条款进行了部分修订。请务必确认内容，在同意后勾选。", //
  login40: "确认", //
  password: "密码",
  login41: "已有账号的用户",
};

t.logistics = {
  logistics1: '物流查询',
  logistics2: '请输入单号',
  logistics3: '查询',
  logistics4: '详细',
  logistics5: '配送状态',
  logistics6: '最新配送状态',
  logistics7: '配送完成日期',
  logistics8: '配送单号',
  logistics9: '发件日期',
  logistics10: '收件营业所',
  logistics11: '配送营业所',
  logistics12: '配送个数',
  logistics13: '物流状态',
  logistics14: '时间',
  logistics15: '营业所',
  logistics16: '您的快递已送到。\n 感谢您的使用。',
  logistics17: '对不起，请确认您的快递单号。',
}
t.FBAContainerOrder = {
  FBAContainerOrder1: '空运',
  FBAContainerOrder2: '海运',
  FBAContainerOrder3: '请选择发件地址',
  FBAContainerOrder4: '请选择收件地址',
  FBAContainerOrder5: '请选择线路',
  FBAContainerOrder6: '请选择物流公司',
  FBAContainerOrder7: '请选择新增商品',
  FBAContainerOrder8: '可申请商品导出',
  FBAContainerOrder9: '出货指示批量上传',
  FBAContainerOrder10: '订单时间',
}
t.cart = {
  cart1: '购物车数量',
  cart2: '购物车预计金额',
  cart3: '选中订单预计金额',
  cart4: '购物车中的订单信息已变更，要保存后再离开吗？',
  cart5: '上次保存时间',
  cart6: '确定',
  cart7: '全选',
  cart8: '请检查序号为',
  cart9: '的订单',
  cart10: '保存',
  cart11: '不保存',
  cart12: '确认提交订单吗?',
  cart13: '第{0}页序号（{1}）',
  cart14: '单价没有输入或者是0，请输入正确的价格',
  cart15: '请输入颜色',
  cart16: '请输入',
  cart17: '请输入ASIN',
  cart18: '请选择水洗标签',
  cart19: '套餐已到期，请联系平台续费。',
  cart20: '请输入贵公司商品的管理代码（内部代码）',
  cart21: '请在亚马逊上输入生成的条形码',
  cart22: '请输入商品上标注（或粘贴）的条形码信息',
  cart23: '请输入店铺商品显示名称',
  cart24: '条形码',
  cart25: '验货代码※商品条形码信息',
  cart26: 'ZOZO 条形码',
  cart27: 'RSL 条形码',
  cart28: '选中订单',
  cart29: '预计金额',
  downloadTemplateVersion: '最新版本更新时间',
  applyMessage22: '一键选择收货地址',
  applyMessage23: '一键委托发货',
  applyMessage24: '收货信息',
  applyMessage25: '选择',
  applyMessage26: '请选择收货地址',
  applyMessage27: '委托自动发货',
  applyMessage28: '修改发货信息',
  applyMessage29: '选择收货信息',
  applyMessage30: '请选择商品',
  applyMessage31: '批量选择收货信息',
  applyMessage32: '收货地址',
  applyMessage33: '请选择收货信息',
  applyMessage34: '确定',
  priceCalcTip: '价格',
  priceCalcTip1: '商品费',
  priceCalcTip2: '检品费',
  priceCalcTip3: '代购手续费',
  start: '起',
  wslang1448: '请选择运输方式',
  wslang671: '已成功',
  wslang261: '请输入充值金额',
  paypalError: '支付失败',
}
t.subAddress = {
  subAddress1: '请输入收件人信息',
  subAddress2: '搜索',
  subAddress3: '选择地址',
  subAddress4: '姓名：',
  subAddress5: '地址：',
  subAddress6: '邮政编码：',
  subAddress7: '公司名称：',
  subAddress8: '备注：',
  subAddress9: '电话：',
  subAddress10: '法人编号：',
  subAddress11: '选择',
  subAddress12: '编辑',
  subAddress13: '请输入收件人',
  subAddress14: '新增地址',
  subAddress15: '国家：',
  subAddress16: '详细地址：',
  subAddress17: '取消',
  subAddress18: '添加并使用',
  subAddress19: '保存修改',
  subAddress20: '请输入姓名',
  subAddress21: '请输入电话',
  subAddress22: '请选择省市区',
  subAddress23: '详细地址，街道，门牌号等',
  subAddress24: '邮政编码',
  subAddress25: '备注',
}
t.switchs = {
  switchs1: '未读消息弹窗提醒：',
  switchs2: '开启',
  switchs3: '关闭',
  switchs4: '开启后在您进入系统时如有未读消息会弹窗提示。',
}
t.diaMsg = {
  msg1: '您有未读消息',
  msg2: '已读并关闭',
  msg3: '回复',
  msg4: '详情',
  msg5: '查看全部消息',
  msg6: '全部已读并关闭',
  msg7: '关闭弹窗提醒',
}
t.diaCloseMsg = {
  msg1: '提醒',
  msg2: '确认关闭未读消息弹窗提醒吗？关闭后您将不会收到消息弹窗，如需再次启动可以在提醒设置页面重新开启。',
  msg3: '确定',
  msg4: '取消',
}
t.search = {
  expandPanel: '展开',
  retractPanel: '收起',
}
t.message = {
  info: "确定要全部已读吗？",
};
t.recycle = {
  recycle1: "回收站",
  recycle2: "状态",
  recycle3: "未读",
  recycle4: "已读",
  recycle5: "全部",
  recycle6: "对话次数",
  recycle7: "对话发起时间",
  recycle8: "删除时间",
  recycle9: "请选择状态",
  recycle10: "客户",
  recycle11: "平台",
  recycle12: "系统",
  recycle13: "确定要把所有信息处理成【已读】吗？",
  recycle14: "是",
  recycle15: "否",
  recycle16: "确定要把所选信息处理成【已读】吗？",
  recycle17: "使用条款和隐私政策修订通知",
  recycle18: "我们修改了使用条款和隐私政策。请确认修改后的内容，同意后再使用服务。",
  recycle19: "修改后的使用条款、隐私政策，可通过以下链接确认。",
  recycle20: "[确认使用条款]",
  recycle21: "[查看隐私政策]",
  recycle22: "请确认内容后，分别勾选。",
  recycle23: "我同意使用条款",
  recycle24: "我同意隐私政策",
  recycle25: "[同意并前进]",
}
t.amazon = {
  amazon01: "Amazon店铺",
  amazon02: "店铺名称",
  amazon03: "卖家编号",
  amazon04: "应用ID",
  amazon05: "客户端令牌",
  amazon06: "客户端编码",
  amazon07: "客户端密钥",
  amazon08: "商品",
  amazon09: "商品管理",
  amazon10: "订单管理",
  amazon11: "库存状态",
  amazon12: "库存阈值",
  amazon13: "销售额",
  amazon14: "库存",
  amazon15: "订单日期",
  amazon16: "买家账号",
  amazon17: "配送渠道",
  amazon18: "销售渠道",
  amazon19: "卖家订单编号",
  amazon20: "已绑定",
  amazon21: "未绑定",
  amazon22: "预警中",
  amazon23: "在售",
  amazon24: "停售",
  amazon25: "手动同步",
  amazon26: "数据正在加载中，请稍等。",
  amazon27: "标准订单",
  amazon28: "长交期订单",
  amazon29: "预售订单",
  amazon30: "缺货订单",
  amazon31: "按需采购订单",
  amazon32: "待处理",
  amazon33: "未发货",
  amazon34: "部分发货",
  amazon35: "已发货",
  amazon36: "已取消",
  amazon37: "无法配送",
  amazon38: "发票未确认",
  amazon39: "等待可用库存",
  amazon40: "已送达",
  amazon41: "一键采购",
  amazon42: "一键发货",
  amazonDoc: "亚马逊店铺绑定流程",
};
t.saas = {
  saas01: "国内信息",
  saas02: "运单号",
}
t.cs = cs
export default t;
